import type { ApiClient } from './client';

export const accountPrivacyMethods = {
  async getEmailStatus(this: ApiClient) {
    const response = await this.makeRequest<any>('/auth/email_status.php', {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });
    return response.data;
  },

  async resendVerification(this: ApiClient) {
    return this.makeRequest('/auth/resend_verification.php', {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({}),
    });
  },

  async verifyEmail(this: ApiClient, token: string, purpose?: string) {
    return this.makeRequest('/auth/verify_email.php', {
      method: 'POST',
      body: JSON.stringify({ token, purpose }),
    });
  },

  async forgotPassword(this: ApiClient, email: string) {
    return this.makeRequest('/auth/forgot_password.php', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },

  async resetPassword(this: ApiClient, token: string, password: string) {
    return this.makeRequest('/auth/reset_password.php', {
      method: 'POST',
      body: JSON.stringify({ token, password }),
    });
  },

  async changeEmail(this: ApiClient, password: string, newEmail: string) {
    return this.makeRequest('/auth/email_change.php', {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ password, new_email: newEmail.trim().toLowerCase() }),
    });
  },

  async savePrivacyConsentRemote(this: ApiClient, payload: Record<string, unknown>) {
    return this.makeRequest('/privacy_consent.php', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: this.getAuthHeaders(),
    });
  },

  async submitPrivacyRequest(this: ApiClient, payload: Record<string, unknown>) {
    return this.makeRequest('/privacy_request.php', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: this.getAuthHeaders(),
    });
  },

  async exportAccountData(this: ApiClient) {
    return this.makeRequest<any>('/account_export.php', {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });
  },
};
